<template>
  <a-modal title="新增地区" style="top: 20px;" :visible="visible" :width="800"
    @cancel="cancleForm" :confirmLoading="confirmLoading" @ok="handleSubmit" >
    <a-form-model :model="form" ref="formRef">
      <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="层级" prop="deep" 
      :rules="{
						  required: true,
						  message: '请选择地区层级',
						  trigger: 'change',
						}">
      <a-select placeholder="请选择地区层级"  v-model="form.deep" @change="changePid" :disabled="typeIndex == 1">
          <a-select-option v-for="(d, index) in deeps" :key="index" :value="d.value">{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :labelCol="labelCol"  :wrapperCol="wrapperCol"  label="上级地区"  prop="pid"  >
      <!-- :rules="{
						  required: true,
						  message: '请选择上级地区',
						  trigger: 'change',
						}" -->
          <a-tree-select allowClear  placeholder="请选择上级地区，如浙江省/杭州市"  :disabled="form.deep==0 || typeIndex == 1"
              :treeData="LocationList" show-search tree-node-filter-prop="title" v-model="form.pid">
			  	</a-tree-select>
      </a-form-model-item>
      <a-form-model-item  :labelCol="labelCol"  :wrapperCol="wrapperCol"  label="名称"  prop="name" 
      :rules="{
					  required: true,
						  message: '请输入行政区简称，如宁夏',
						  trigger: 'change',
						}"
      >
        <a-input placeholder="请输入行政区简称，如宁夏" v-model="form.name"/>
      </a-form-model-item>
      <a-form-model-item  :labelCol="labelCol"  :wrapperCol="wrapperCol"  label="全称"  prop="extName" :rules="{
						  required: true,
						  message: '请输入行政区全称，如宁夏回族自治区',
						  trigger: 'change',
						}" >
        <a-input placeholder="请输入行政区全称，如宁夏回族自治区" v-model="form.extName"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>

import { districts } from '@/api/Industry'
import { saveDist, getDistList, districtsAdd , districtsEdit} from '@/api/system'
import pick from 'lodash.pick'
export default {
  name: 'DictModal',
  props: {
    deeps: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      typeIndex: '',
      form: {
         deep: undefined,
      pid: undefined,
      name: '',
      extName: '',

      },
      LocationList: [],
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      city: [],
      // form: this.$form.createForm(this)
    }
  },
  beforeCreate () {
  },
  created () {
    getDistList(Object.assign({ deep: 0 })).then(res => {
      this.options = res.rows.map(d => {
        return { value: d.id, label: d.name, isLeaf: false }
      })
    })
  },
  methods: {
    changePid() {
      // this.form.pid = ''
    },
    cancleForm() {
      this.$refs.formRef.resetFields()
      this.visible = false
      this.form =  {
           deep: undefined,
           pid: undefined,
           name: '',
           extName: '',

      }

    },

    add () {
      this.typeIndex = 0
      // this.$formRef.resetFields()
      this.form =  {
           deep: undefined,
           pid: undefined,
           name: '',
           extName: '',

      }
       this.visible = true
      this.getLocalData()
      // this.edit({ dictId: 0 })
    },
    getLocalData() {
        districts().then((res) => {
      // console.log(this.$store.getters, 'this.$store.getters===================================')
      console.log(res.data.tree, 'res.data.tree=========================')
      // this.LocationList = res.data.tree
      
        const list = res.data.tree
        list.forEach( item => {
          item.value = item.id
          item.title = item.extName
          if(item.children.length >= 0 ) {
             item.children.forEach( item1 => {
                item1.value = item1.id
                item1.title = item1.extName
                if(item1.children.length >= 0) {
                  delete item1['children']
                }
             })
           
          }


        })   
        this.LocationList = list 
        console.log(list , 'list ==========================')
    })

    },
    edit (record) {
      this.typeIndex = 1
      console.log(record, 'record====================')
      if(record.pid == 0) {
          record.pid = undefined
      }
      this.form = JSON.parse(JSON.stringify(record))
      // Object.assign(record)
      this.visible = true
       this.getLocalData()
        
      // this.$nextTick(() => {
      //   this.form.setFieldsValue(pick(this.mdl, 'id', 'deep', 'name', 'pinyin', 'pinyinShor', 'extName'))
      // })
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true

      getDistList(Object.assign({ pid: targetOption.value })).then(res => {
        targetOption.loading = false
        targetOption.children = res.rows.map(d => {
          return { value: d.id, label: d.name, isLeaf: d.deep === 2 }
        })
        this.options = [...this.options]
      })
    },
    handleSubmit (e) {
      //表单提交
       this.$refs.formRef.validate(valid => {
        if(valid) {
          if(this.form.deep == 0) {
            this.form.pid = 0
          }
          if(this.typeIndex == 0) {
              districtsAdd(this.form).then(res => {
            if(res.code == 200) {
              this.$refs.formRef.resetFields()
              this.visible = false
              this.form =  {
                   deep: undefined,
                   pid: undefined,
                   name: '',
                   extName: '',
                  }
              this.$message.success(res.msg)
              // 刷新列表
              this.$emit('refresh')
            }else {
              this.$message.error(res.error)
            }
        console.log(res, 'res========================')
      })
          } else {
            districtsEdit(this.form).then(res=> {
               if(res.code == 200) {
               this.$refs.formRef.resetFields()
              this.visible = false
              this.form =  {
                   deep: undefined,
                   pid: undefined,
                   name: '',
                   extName: '',
                  }
              this.$message.success(res.msg)
              // 刷新列表
              this.$emit('refresh')
            } else {
              this.$message.error(res.error)
            }

            })
          }
          
        
        }
       })
      
      // e.preventDefault()
      // this.$message.success('your select dist is ' + this.city)
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     console.log('Received values of form: ', values)
      //     this.confirmLoading = true
      //     saveDist(values).then(res => {
      //       if (res.code === 200) {
      //         this.$message.success('保存成功')
      //         this.$emit('ok')
      //         this.visible = false
      //       } else {
      //         this.$message.success(res.msg)
      //       }
      //     }).catch(() => {
      //       this.$message.error('系统错误，请稍后再试')
      //     }).finally(() => {
      //       this.confirmLoading = false
      //     })
      //   }
      // })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
